import { WP_REST_BASE_URL } from "@/config/site";

export async function getPosts(
  limit?: string,
  page?: string,
  type?: string,
  baseUrl: string = WP_REST_BASE_URL
) {
  const queryParams = new URLSearchParams({
    _embed: "1",
  });

  if (limit) {
    queryParams.append("per_page", limit);
  }

  if (page) {
    queryParams.append("page", page);
  }

  const res = await fetch(`${baseUrl}/${type}?${queryParams}`, {
    next: { revalidate: 60 },
  });

  if (!res.ok) {
    throw new Error("Failed to fetch posts");
  }

  return res.json();
}

export async function getPost(slug: string, type: string, baseUrl: string = WP_REST_BASE_URL) {
  const res = await fetch(`${baseUrl}/${type}?slug=${slug}&_embed=1`, {
    next: { revalidate: 60 },
  });

  if (!res.ok) {
    throw new Error("Failed to fetch post");
  }

  const posts = await res.json();
  return posts.length > 0 ? posts[0] : null;
}


export async function getAdjacentPosts(
  currentPostDate: string,
  restBaseUrl: string
) {
  // Get previous post (published before current post)
  const previousPost = await fetch(
    `${restBaseUrl}/posts?before=${currentPostDate}&orderby=date&order=desc&per_page=1&_embed=true`,
    { next: { revalidate: 3600 } }
  ).then((res) => res.json());

  // Get next post (published after current post)
  const nextPost = await fetch(
    `${restBaseUrl}/posts?after=${currentPostDate}&orderby=date&order=asc&per_page=1&_embed=true`,
    { next: { revalidate: 3600 } }
  ).then((res) => res.json());

  return {
    previousPost: previousPost[0] || null,
    nextPost: nextPost[0] || null,
  };
}

// Tambahkan fungsi baru untuk mengambil posts berdasarkan tag
export async function getPostsByTag(
  tagId: string,
  limit?: string,
  page?: string,
  baseUrl: string = WP_REST_BASE_URL
) {
  const queryParams = new URLSearchParams({
    _embed: "1",
    tags: tagId,
  });

  if (limit) {
    queryParams.append("per_page", limit);
  }

  if (page) {
    queryParams.append("page", page);
  }

  const res = await fetch(`${baseUrl}/posts?${queryParams}`, {
    next: { revalidate: 60 },
  });

  if (!res.ok) {
    throw new Error("Failed to fetch posts by tag");
  }

  return res.json();
}




export async function getPostsSearchResults(searchTerm: string, baseUrl: string = WP_REST_BASE_URL) {
  const res = await fetch(`${baseUrl}/posts?search=${searchTerm}&_embed=1`);

  if (!res.ok) {
    throw new Error("Failed to fetch posts");
  }

  return res.json();
}

export async function getProjectsSearchResults(searchTerm: string, baseUrl: string = WP_REST_BASE_URL) {
  const res = await fetch(`${baseUrl}/projects?search=${searchTerm}&_embed=1`);

  if (!res.ok) {
    throw new Error("Failed to fetch projects");
  }

  return res.json();
}

export async function getServicesSearchResults(searchTerm: string, baseUrl: string = WP_REST_BASE_URL) {
  const res = await fetch(`${baseUrl}/services?search=${searchTerm}&_embed=1`);

  if (!res.ok) {
    throw new Error("Failed to fetch services");
  }

  return res.json();
}

